module.exports = __webpack_public_path__ + "media/images/carrusel/cajas-86c55e24eadf35e857680f0cc4fb6cc2.jpg";